import { DismissableLayerProps } from '@radix-ui/react-select'
import { ReactNode } from 'react'

export interface ConfirmationDialogProps {
  isOpen?: boolean
  onOpenChange?: (isOpen: boolean) => void
  title: string
  message?: ReactNode
  onConfirm?: () => void
  onCancel?: () => void
  icon?: string
  hasCancelButton?: boolean
  labelConfirm?: string
  labelCancel?: string
  disabled?: boolean
  loading?: boolean
  kind?: ConfirmationDialogKind
  className?: string
  description?: string
  onEscapeKeyDown?: DismissableLayerProps['onEscapeKeyDown']
  onPointerDown?: DismissableLayerProps['onPointerDown']
  onInteractOutside?: DismissableLayerProps['onInteractOutside']
  overlayClassName?: string
  confirmationText?: string
  confirmationInputProps?: {
    placeholder?: string
    className?: string
  }
  destructiveActionText?: string
  destructiveActionInputProps?: {
    placeholder?: string
    className?: string
  }
  confirmationValue?: string
  onConfirmationChange?: (value: string) => void
  destructiveValue?: string
  onDestructiveChange?: (value: string) => void
}

export enum ConfirmationDialogKind {
  information = 'information',
  danger = 'danger',
}
